import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import MarketsPageViewModel from './MarketsPageViewModel.type';

type MarketPageType = MarketsPageViewModel & PageType;

export default (currentPage: PageType): currentPage is MarketPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Markets_MarketsPageViewModel;
};
